'use client';

import Box from '@mui/material/Box';
import { keyframes } from '@mui/system';

// ----------------------------------------------------------------------

type Props = {
  backgroundColor: string;
  durationMs: number;
  onAnimationEnd: () => void;
};

/** Old theme overlay wipes away left→right, revealing new theme underneath */
const leftToRightWipeAway = keyframes`
  0% {
    clip-path: inset(0 0 0 0);
  }
  100% {
    clip-path: inset(0 0 0 100%);
  }
`;

export function ThemeTransitionOverlay({
  backgroundColor,
  durationMs,
  onAnimationEnd,
}: Props) {
  return (
    <>
      {/* Block all interaction during transition */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 99998,
          pointerEvents: 'auto',
          cursor: 'wait',
        }}
      />
      {/* Animated reveal overlay */}
      <Box
        onAnimationEnd={onAnimationEnd}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 99999,
          pointerEvents: 'none',
          backgroundColor,
          animation: `${leftToRightWipeAway} ${durationMs}ms cubic-bezier(0.4, 0, 0.2, 1) forwards`,
          clipPath: 'inset(0 0 0 0)',
        }}
      />
    </>
  );
}
